import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

let echoInstance = null;
const orderListeners = new Set();
let channelBound = false;

const reverbEnabled = () =>
  Boolean(
    process.env.REACT_APP_REVERB_APP_KEY &&
      process.env.REACT_APP_REVERB_HOST &&
      process.env.REACT_APP_REVERB_PORT
  );

/**
 * Singleton Laravel Echo client pointed at the local Reverb websocket server.
 * Returns null when Reverb env vars are missing so the app can fall back to polling.
 */
export const getEcho = () => {
  if (!reverbEnabled()) {
    return null;
  }

  if (echoInstance) {
    return echoInstance;
  }

  echoInstance = new Echo({
    broadcaster: "reverb",
    key: process.env.REACT_APP_REVERB_APP_KEY,
    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: Number(process.env.REACT_APP_REVERB_PORT || 8080),
    wssPort: Number(process.env.REACT_APP_REVERB_PORT || 8080),
    forceTLS: (process.env.REACT_APP_REVERB_SCHEME || "http") === "https",
    enabledTransports: ["ws", "wss"],
    disableStats: true,
  });

  return echoInstance;
};

const dispatchOrderEvent = (payload) => {
  orderListeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (err) {
      console.warn("Order listener failed:", err);
    }
  });
};

const ensureChannelBound = () => {
  const echo = getEcho();
  if (!echo || channelBound) {
    return echo;
  }

  echo.channel("safem.orders").listen(".OrderChanged", (payload) => {
    dispatchOrderEvent(payload);
  });
  channelBound = true;
  return echo;
};

/**
 * Subscribe to the public safem.orders channel. Multiple components can
 * subscribe safely - the channel is only left when the last listener unsubscribes.
 * Returns an unsubscribe function.
 */
export const subscribeToOrders = (onOrderChanged) => {
  if (!reverbEnabled()) {
    return () => {};
  }

  ensureChannelBound();
  orderListeners.add(onOrderChanged);

  return () => {
    orderListeners.delete(onOrderChanged);

    if (orderListeners.size === 0 && echoInstance && channelBound) {
      try {
        echoInstance.leave("safem.orders");
      } catch (err) {
        console.warn("Failed to leave orders channel:", err);
      }
      channelBound = false;
    }
  };
};
